export default "__VITE_ASSET__f9199e33__"